export default "__VITE_ASSET__jtr3ByxH__"